<template>
  <div class="page">
    <Header title="活动画廊">
      <span class="nav-right-text" slot="right" @click.stop="viewSubmission">我要投稿</span>
    </Header>

    <div class="category-name">{{ categoryInfo.categoryName }}</div>

    <van-swipe v-if="photoList.length > 0" :autoplay="0" class="photo-container" @change="onSwipeChange">
      <van-swipe-item v-for="photo in photoList" :key="photo.photoId" class="photo-image">
        <img :src="getImageUrl(photo.photoFileUri)" @click="viewPhoto(photo)" />
      </van-swipe-item>
    </van-swipe>

    <div class="index-line">
      滑动查看下一张图片 ({{ (curIndex + 1) }}/{{ totalCount }})
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import galleryApi from '@/api/gallery'
import { commonUtils } from '@/utils/common'
export default {
  name: 'GalleryPhotoList',
  components: {
    Header
  },
  data () {
    return {
      categoryId: '',
      categoryInfo: {},
      photoList: [],
      curIndex: 0
    }
  },
  computed: {
    totalCount () {
      return this.photoList.length
    }
  },
  created () {
    this.categoryId = this.$route.params.categoryId
    this.queryCategoryById()
    this.queryPhotoList()
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,

    queryCategoryById () {
      galleryApi.queryGalleryCategoryById(this.categoryId).then(response => {
        if (response.data.resultCode === '0') {
          this.categoryInfo = response.data.resultData.categoryDTO
        }
      })
    },

    queryPhotoList () {
      this.photoUrlList = []
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取数据'
      })
      const params = {
        categoryId: this.categoryId
      }
      galleryApi.queryGalleryPhotoList(params).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.photoList = response.data.resultData.photoList
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    viewPhoto (photo) {
      window.location.href = this.getImageUrl(photo.photoFileUri)
    },

    viewSubmission () {
      this.$router.push('/gallery/submission')
    },

    onSwipeChange (index) {
      this.curIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
.category-name {
  color: #117281;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
}
.photo-container {
  width: 90%;
  margin: 6px auto 12px auto;

  /deep/ .van-swipe__indicators {
    bottom: 0;
  }
  /deep/ .van-swipe__indicator--active {
    background-color: #117281;
  }
}

.photo-image {
  width: 100%;
  margin: 5px auto 10px auto;
  text-align: center;
  max-height: 400px;
  line-height: 400px;
  img {
    max-width: 100%;
    max-height: 400px;
    vertical-align: middle;
  }
}

.index-line {
  color: #117281;
  font-size: 16px;
  margin: 16px;
  text-align: center;
}
</style>
